import { render, staticRenderFns } from "./UpdateCustomerCurrencyPopUp.vue?vue&type=template&id=10095da6&scoped=true&"
import script from "./UpdateCustomerCurrencyPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomerCurrencyPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCustomerCurrencyPopUp.vue?vue&type=style&index=0&id=10095da6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10095da6",
  null
  
)

export default component.exports